<template>
  <div class="container is-boxed-fluid multi-page section">
    <div class="row fullscreen-content">
      <div class="col-3 col-xs-12 col-sm-12 col-ms-12 col-md-12">
        <ul class="page-navigation">
          <li v-for="(item, key) in $t('static_page_nav')" :key="key">
            <router-link :to="$i18nRoute({name: item.name, params: item.params})">{{ item.title }}</router-link>
          </li>
        </ul>
      </div>
      <div class="col-9 col-xs-12 col-sm-12 col-ms-12 col-md-12 page-body">
        <div class="fadeDown" v-html="page.data.content" v-show="!page.loading"></div>
        <div class="static-page-loading fade" v-show="page.loading">
          <ul>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data () {
    return {

    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.multi-page {
  padding-top: 130px;
  .page-navigation {
    list-style: none;
    position: sticky;
    top: 130px;

    & > li {
      border-top: 1px solid $main-color;

      &:last-child {
        border-bottom: 1px solid $main-color;
      }

      & > a {
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;

        &.router-link-active {
          color: $main-color;
          position: relative;
          padding-right: 40px;
          font-family: $font-bold;

          &:after {
            content: "";
            width: 12px;
            height: 12px;
            border-bottom: 1px solid $main-color;
            border-right: 1px solid $main-color;
            transform: rotate(-45deg);
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 15px;
          }

          & + ul {
            display: block;
          }
        }
      }

      ul {
        list-style: none;
        display: none;
        margin-bottom: 10px;

        li {
          a {
            display: block;
            padding-top: 10px;
            padding-bottom: 10px;

            &:hover,
            &.router-link-exact-active {
              color: $main-color;
            }
          }
        }
      }
    }
  }

  .page-body {
    @include mq($media-md) {
      margin-top: 30px;
    }

    ul {
      list-style-position: inside;
      list-style: disc;
      padding-left: 20px;
    }

    h1,
    h2 {
      font-weight: normal;
      font-family: $font-bold;
      font-size: 16px;
      margin-top: 0;
      margin-bottom: 20px;
    }

    p {
      line-height: 24px;
      margin-top: 0;
      margin-bottom: 15px;
    }

    .static-page-loading {
      ul {
        li {
          height: 20px;
          margin-bottom: 15px;
          animation: gradient 0.7s infinite;
          list-style: none;

          &:nth-child(1) {
            width: 60%;
          }
          &:nth-child(2) {
            width: 75%;
          }
          &:nth-child(3) {
            width: 70%;
          }
          &:nth-child(4) {
            width: 65%;
          }
          &:nth-child(5) {
            width: 95%;
          }
          &:nth-child(6) {
            width: 73%;
          }
          &:nth-child(7) {
            width: 45%;
          }
          &:nth-child(8) {
            width: 70%;
          }
          &:nth-child(9) {
            width: 50%;
          }
          &:nth-child(10) {
            width: 86%;
          }
          &:nth-child(11) {
            width: 75%;
          }
          &:nth-child(12) {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
